import { render, staticRenderFns } from "./CreateContentDialog.vue?vue&type=template&id=6472589f&scoped=true"
import script from "./CreateContentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateContentDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CreateContentDialog.vue?vue&type=style&index=0&id=6472589f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472589f",
  null
  
)

export default component.exports